import React from 'react'

import * as firebase from 'firebase';
import { connect } from 'react-redux'

import Popover from 'material-ui/Popover';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';

class WorkerFilterButton extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedWorkers: [],
      openPopover: false,
      searchFilter: ''
    }
    this.onAllWorkersClick = this.onAllWorkersClick.bind(this)
    this.listener = this.onUpdate.bind(this)
    this.dbPath = `users/${props.userAuth.id}/settings/selectedWorkers/${props.teamId}/`
  }

  componentWillMount(nextProps) {
    this.props.onSelectionChange(this.state.selectedWorkers);
  }

  componentDidMount() {
    // Start querying and listening for changes
    firebase.database().ref(this.dbPath).on('value', this.listener);
  }

  componentWillUnmount() {
    firebase.database().ref(this.dbPath).off('value', this.listener);
  }

  onUpdate(snapshot) {
    let value = snapshot.val();
    let newSelectedWorkers;
    // Get list of tasks
    if (!value || value.everyone) {
      newSelectedWorkers = this.props.allWorkers;
    } else if (!value.list) {
      newSelectedWorkers = [];
    } else {
      newSelectedWorkers = [];
      Object.keys(value.list).forEach(workerId => {
        const worker = this.props.allWorkers.find(user => user.userId === workerId)
        if (worker){
          newSelectedWorkers.push(worker)
        }
      })
    }

    this.setState({
      selectedWorkers: newSelectedWorkers
    })
    this.props.onSelectionChange(newSelectedWorkers);
  }

  onAllWorkersClick(isChecked) {
    firebase.database().ref(this.dbPath).set({ everyone: isChecked });
  }

  onCheck(workerId, isChecked) {
    const newSelectedWorkers = this.state.selectedWorkers.slice();
    const workerIndex = this.props.allWorkers.findIndex(user => workerId === user.userId);
    const indexInSelection = this.state.selectedWorkers.findIndex(user => workerId === user.userId);

    if (isChecked) {
      if (indexInSelection === -1) {
        newSelectedWorkers.push(this.props.allWorkers[workerIndex])
      }
    }
    else {
      if (indexInSelection !== -1) {
        newSelectedWorkers.splice(indexInSelection, 1);
      }
    }

    // Save new list of selected workers into the db
    const updates = {};
    if (newSelectedWorkers.length === this.props.allWorkers.length) {
      updates[this.dbPath] = { everyone: true };
    } else {
      updates[this.dbPath + 'everyone'] = false;

      const list = {};
      newSelectedWorkers.forEach(worker => list[worker.userId] = true);
      updates[this.dbPath + 'list'] = list;
    }

    firebase.database().ref().update(updates);
  }

  renderItem(worker) {
    const workerId = worker.userId;
    const label = worker.displayName;
    let checkColor = '#8c8c8c';
    const isSelected = -1 !== this.state.selectedWorkers.findIndex(user => workerId === user.userId);
    return (
      <div
        key={workerId}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: 8,
        }}
        onTouchTap={(event) => {
          this.onCheck(workerId, !isSelected)
        }}>
        <Checkbox
          style={{
            width: '24px',
            alignItems: 'center'
          }}
          iconStyle={{
            fill: checkColor
          }}
          checked={isSelected}/>
        <span
          style={{fontSize: 16}}>
          {label}
        </span>
      </div>
    );
  }

  renderAllItemsOption() {
    let checkColor = '#8c8c8c';
    const countOfSelected = this.state.selectedWorkers.length;
    const total = this.props.allWorkers.length;
    const isSelected = countOfSelected === total;
    const label = "All";
    return (
      <div
        key={-1}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: 8
        }}
        onTouchTap={(event) => {
          this.onAllWorkersClick(!isSelected);
        }}>
        <Checkbox
          style={{
            width: '24px',
            alignItems: 'center'
          }}
          iconStyle={{
            fill: checkColor
          }}
          checked={isSelected}/>
        <span
          style={{fontSize: 16}}>
          {label}
        </span>
      </div>
    );
  }

  renderWorkers() {
    const views = [];
    views.push(this.renderAllItemsOption());
    views.push(
      <Divider
        style={{
          marginTop: 4,
          marginBottom: 4
        }}
        key='divider'/>
    );

    const searchFilter = this.state.searchFilter.toLowerCase();
    for (let i = 0; i < this.props.allWorkers.length; i++) {
      const worker = this.props.allWorkers[i];
      const workerName = worker.displayName.toLowerCase();
      if (searchFilter === '' || workerName.indexOf(searchFilter) !== -1) {
        views.push(this.renderItem(worker));
      }
    }
    return views;
  }

  renderSearch() {
    return (
      <TextField
        key="text-field"
        style={{ margin: 4, marginTop: 0, width: '100%' }}
        hintText="Search"
        value={this.state.searchFilter}
        onChange={(event, newValue) => this.setState({ searchFilter: newValue })}/>
    )
  }

  render() {
    let buttonLabel = 'Everyone';
    const countOfSelected = this.state.selectedWorkers.length;
    const total = this.props.allWorkers.length;
    if (countOfSelected !== total) {
      buttonLabel = countOfSelected === 1
        ? this.state.selectedWorkers[0].displayName
        : countOfSelected.toString() + ' Workers';
    }
    return (
      <div
        style={Object.assign({ float: 'left', backgroundColor: '#fafafa',
          marginRight: 10 }, this.props.style)}
        ref='root'>
        <FlatButton
          onTouchTap={(event) => {
            event.preventDefault();
            this.setState({ openPopover: true });
          }}
          style={{
            border: '1px solid #e2e2e2',
            width: 152
          }}>
          <span
            style={{
              color: '#4d6f7f',
              textTransform: 'none',
              float: 'left',
              marginLeft: 17,
              fontSize: 14
            }}>
            {buttonLabel}
          </span>
          <FontIcon
            className="material-icons"
            color='#4d6f7f'
            style={{
              paddingTop: 5,
              marginRight: 13,
              float: 'right'
            }}>
            keyboard_arrow_down
          </FontIcon>
        </FlatButton>
        <Popover
          open={this.state.openPopover}
          anchorEl={this.refs.root}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={() => this.setState({openPopover: false})}>
          <div
            style={{ maxHeight: 350, padding: 10 }}>
            {this.renderSearch()}
            {this.renderWorkers()}
          </div>
        </Popover>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let allWorkers = [];
  let teamId = undefined;

  const teamInfo = state.firebase.team;
  if (teamInfo){
    if (teamInfo.members && !teamInfo.members.loading) {
      allWorkers = teamInfo.members.value;
    }
    if (teamInfo.metadata && !teamInfo.metadata.loading) {
      teamId = teamInfo.metadata.value.id;
    }
  }

  return {
    teamId: teamId,
    allWorkers: allWorkers,
    userAuth: state.firebase.userAuth
  }
};

export default connect(mapStateToProps)(WorkerFilterButton);



// WEBPACK FOOTER //
// ./src/common/WorkerFilterButton.js